<template>
	<div
		:class="{
			'py-4 px-6': !borderless,
			'bottom-sheet-content': isBottomSheet,
		}"
		class="width-full d-flex flex-column flex-grow-1 overflow-auto"
		:style="bottomSheetContentStyle"
	>
		<slot />
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import type { DialogBottomSheetType } from './dialogTypes'

	interface Props {
		borderless?: boolean
		isBottomSheet?: boolean
		bottomSheetType?: DialogBottomSheetType
	}

	const props = withDefaults(defineProps<Props>(), {
		borderless: false,
		bottomSheetType: 'medium',
	})

	const percentageRelativeScreen: Record<DialogBottomSheetType, number> = {
		collapsed: 25,
		medium: 50,
		expanded: 80,
	}

	const bottomSheetContentStyle = computed(() => {
		if (!props.isBottomSheet) return {}
		const percent = percentageRelativeScreen[props.bottomSheetType]
		return {
			'--bottom-sheet-height': `${percent}dvh`,
		}
	})
</script>

<style scoped>
	.bottom-sheet-content {
		max-height: var(--bottom-sheet-height);
	}
</style>
